export enum MediaAssetType {
  Audio = "Audio",
  Video = "Video",
}

export enum OutputGroupType {
  FILE = "File",
}
